import {
  MULTICURRENCY_RECHARGE,
  MULTICURRENCY_PAYCONFIRM,
  MULTICURRENCY_SAVECARDOFINTENT
} from "../apis/payment";
var paymentEz;
export default {
  data() {
    return {
      pgSdk: null
    };
  },
  methods: {
    loadPaymentEzScript(success = () => {}) {
      // console.log(publicKey)
      if (!paymentEz) {
        paymentEz = window.document.createElement("script");
        paymentEz.src =
          "https://cdn.paymentez.com/ccapi/sdk/payment_checkout_3.0.0.min.js";
        paymentEz.onload = () => {
          console.log("loadPaymentEz成功===========");
          success && success();
        };
        var head =
          window.document.head ||
          window.document.getElementsByTagName("head")[0] ||
          window.document.documentElement;
        head.insertBefore(paymentEz, head.firstChild);
      } else {
        console.log("PaymentEz已加载");
        success && success();
      }
    },
    initPaymentEzStableSdk(success = () => {}) {
      // console.log(publicKey)
      if (!paymentEz) {
        paymentEz = window.document.createElement("script");
        paymentEz.src =
          "https://cdn.paymentez.com/ccapi/sdk/payment_sdk_stable.min.js";
        paymentEz.onload = () => {
          console.log("loadPaymentEz成功===========");
          success && success();
        };
        var head =
          window.document.head ||
          window.document.getElementsByTagName("head")[0] ||
          window.document.documentElement;
        head.insertBefore(paymentEz, head.firstChild);
      } else {
        console.log("PaymentEz已加载");
        success && success();
      }
    },
    paymentEzSaveCardOfIntent(payInfo, callback = () => {}) {
      const query = { paymentId: payInfo.pId };
      const headers = {
        headers: { "Content-Type": "application/json;charset=UTF-8" }
      };
      this.$Request("POST", MULTICURRENCY_SAVECARDOFINTENT, query, headers)
        .then(resp => {
          callback(resp);
        })
        .catch(err => {
          callback(err);
        });
    },
    // 加载Paymentez稳定版SDK
    loadPaymentEzScriptStable(payInfo, payment, success = () => {}) {
      console.log("🚀 ~ payment:", payment, "🚀 ~ payInfo:", payInfo);
      this.initPaymentEzStableSdk(() => {
        this.isPaymentEzPopup = true;
        this.pgSdk = new PaymentGateway(
          payment.environment, // `prod`, `stg`, `local` to change environment. Default is `stg`
          payment.applicationCode,
          payment.applicationKey
        );
        payment.user.email = payment.user.email || "jhon@doe.com"; // todo
        let getTokenizeData = () => {
          let data = {
            locale: payment.locale || "en",
            user: payment.user,
            configuration: {
              default_country: payment.defaultCountry || "ECU"
            }
          };
          return data;
        };

        let notCompletedFormCallback = message => {
          console.log("🚀 ~ notCompletedFormCallback ~ message:", message);
          // document.getElementById(
          //   "response"
          // ).innerHTML = `Not completed form: ${message}, Please fill required data`;
          // submitButton.innerText = submitInitialText;
          // submitButton.removeAttribute("disabled");
        };
        const reloadTokenize = () => {
          this.pgSdk.generate_tokenize(
            getTokenizeData(),
            "#paymentEz-element",
            responseCallback,
            notCompletedFormCallback
          );
          this.pgSdk.tokenize();
          setTimeout(() => {
            this.pgSdk.tokenize();
          }, 300);
        };
        // Tokenize Callbacks
        let responseCallback = response => {
          console.log("🚀 ~ responseCallback ~ response:", response);
          console.info(`responseCallback~response:${JSON.stringify(response)}`);
          this.$loading(true);
          const _card = (response && response.card) || {};
          if (response.error && response.error.description) {
            this.$toast(response.error.help);
            reloadTokenize();
          } else if (_card && _card.status) {
            if (_card.status === "rejected") {
              this.$toast("Payment was rejected");
              reloadTokenize();
            } else if (_card.status === "review") {
              this.$toast(
                `${_card.status}: Payment failed. Try using another card.`
              );
              reloadTokenize();
            } else {
              success(response);
            }
          }
        };
        this.pgSdk.generate_tokenize(
          getTokenizeData(),
          "#paymentEz-element",
          responseCallback,
          notCompletedFormCallback
        );
      });
    },
    onPaymentEzSetup() {
      console.log("onPaymentEzSetup");
      // this.$loading(true);
      this.pgSdk.tokenize();
      // event.preventDefault();
    },
    // Paymentez充值/支付
    onPaymentEzRecharge(datas, success = () => {}) {
      let _this = this;
      const headers = {
        headers: { "Content-Type": "application/json;charset=UTF-8" }
      };
      this.$post(
        MULTICURRENCY_RECHARGE,
        datas,
        resp => {
          if (datas.token || datas.userCardId) {
            success(resp.data);
            return;
          }
          const payInfo = resp.data.paymentInfo || {};
          if (payInfo && payInfo.error) {
            this.$toast(payInfo.error.type || "Payment Error");
            return;
          }
          this.$loading(false);
          this.loadPaymentEzScript(() => {
            // eslint-disable-next-line new-cap
            this.paymentEzCheckout = new PaymentCheckout.modal({
              env_mode: resp.data.paymentInfo.live ? "prod" : "stg", // `prod`, `stg`, `local` to change environment. Default is `stg`
              onOpen: function(info) {
                console.log("modal open", info);
              },
              onClose: function(error) {
                console.log("modal closed", error);
              },
              onResponse: function(response) {
                console.log("modal response", response);
                const transaction = response.transaction || {};
                if (response.error && response.error.description) {
                  _this.$toast(response.error.description);
                } else if (transaction && transaction.status === "failure") {
                  _this.$toast(`${transaction.status}: ${transaction.message}`);
                } else if (transaction && transaction.status === "success") {
                  resp.data.transaction = transaction;
                  success(resp.data);
                }
              }
            });
            this.paymentEzCheckout.open({
              reference: resp.data.paymentInfo.reference
            });
          });
        },
        error => {
          this.$loading(false);
          console.log(error);
        },
        headers
      );
    },
    onPaymentEzCard(callback) {
      this.$loading(true);
      // 创建支付意图成功回调
      const EzRecharge = response => {
        this.isPaymentEzPopup = false;
        if (response.card && response.card.token) {
          callback && callback(response);
        }
      };
      // 支付意图
      this.paymentEzSaveCardOfIntent(this.payInfo, (resp = {}) => {
        this.$loading(false);
        if (resp.data) {
          // 加载支付
          this.loadPaymentEzScriptStable(this.payInfo, resp.data, EzRecharge);
        }
      });
    },
    appPaymentEz(paymentInfo, callback) {
      // 创建支付意图成功回调
      const EzRecharge = response => {
        this.isPaymentEzPopup = false;
        if (response.card && response.card.token) {
          callback && callback(response);
        }
      };
      // 加载支付
      this.loadPaymentEzScriptStable(paymentInfo, paymentInfo, EzRecharge);
    },
    confirmCardPaymentEz(outTradeNo, tradeNo) {
      this.$loading(true);
      this.$get(
        `${MULTICURRENCY_PAYCONFIRM}?outTradeNo=${outTradeNo}&tradeNo=${tradeNo}`,
        {},
        resp => {
          this.$loading(false);
          if (resp.data) {
            this.$router.replace(
              `/result?tradeNo=${resp.data.orderId}&payMode=paymentez&payType=${this.payType}`
            );
          }
        },
        error => {
          this.$loading(false);
          this.$toast(error);
          console.log(error);
        },
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      );
    }
  }
};
